import { gql } from '@apollo/client';
import { textPairFragment, paymentFragment, addressFragment } from '../../query/fragments';

// hasProfileCompletionEnabled will be cleaned up with ACCT-893
export const PAYMENT_INFO_TEXT_QUERY = gql`
  query PaymentInfoTextQuery {
    textFor {
      paymentCardTitle: pair(pairKey: "paymentCardTitle") { ...textPair }
      paymentCardDefault: pair(pairKey: "paymentCardDefault") { ...textPair }
      changeText: pair(pairKey: "change") { ...textPair }
      noDefaultPayment: pair(pairKey: "noDefaultPayment") { ...textPair }
      selectPayment: pair(pairKey: "selectPayment") { ...textPair }
      addPayment: pair(pairKey: "addPayment") { ...textPair }
      myInfoPayment: pair(pairKey: "myInfoPayment") { ...textPair }
      myInfoPaymentDescription: pair(pairKey: "myInfoPaymentDescription") { ...textPair }
    }
    getDefaultPayment { ...payment }
    getPaymentPageURL
  }

  ${textPairFragment}
  ${paymentFragment}
`;

// hasProfileCompletionEnabled will be cleaned up with ACCT-893
export const MY_ADDRESS_QUERY = gql`
  query MyAddressQuery {
    getDefaultAddress { ...address }
    getAddressPageURL
    textFor {
      addressCardTitle: pair(pairKey: "addressCardTitle") { ...textPair }
      addressCardDefault: pair(pairKey: "addressCardDefault") { ...textPair }
      changeText: pair(pairKey: "change") { ...textPair }
      noDefaultAddress: pair(pairKey: "noDefaultAddress") { ...textPair }
      myInfoAddress: pair(pairKey: "myInfoAddress") { ...textPair }
      myInfoAddressDescription: pair(pairKey: "myInfoAddressDescription") { ...textPair }
      selectAddress: pair(pairKey: "selectAddress") { ...textPair }
      addAddress: pair(pairKey: "addAddress") { ...textPair }
    }
  }

  ${addressFragment}
  ${textPairFragment}
`;

export const ACCOUNT_DISPLAY_TEXT_QUERY = gql`
  query AccountDisplayTextQuery {
    textFor {
      pageTitle: pair(pairKey: "accountDisplayTitle") { ...textPair }
      profileCompletionSuccessText: pair(pairKey: "profileCompletionSuccess") { ...textPair }
    }
    hasProfileCompletionEnabled: featureFlag(
        key: "has-profile-completion-enabled",
        defaultValue: false
      )
  }

  ${textPairFragment}
`;
